document.addEventListener('DOMContentLoaded', () => {
  // do your setup here
  var $ = require('jquery');
  console.log('Testing!');
});
